module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-07.2ee091bd.jpg";